import { bl_fi_fixed_asset_register_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class AssetRegisterContainerModel extends BaseContainerModel {
  bl_fi_fixed_asset_register_hdr: bl_fi_fixed_asset_register_hdr_RowClass = new bl_fi_fixed_asset_register_hdr_RowClass();
}

export class AssetRegisterQueryCriteria {
  offset: number;
  limit: number;
  orderBy: string;
  order: string;
  keyword: string;
  txn_type: string;
  code: string;
  name: string;
  descr: string;
  status: string;
  param_code: string;
  value_string: string;
}
